<template>
  <div class="picmanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;" :border="true" >
      
      <el-table-column prop="name" align="center" label="部门名称"> </el-table-column>

      <el-table-column prop="status"  width="200" align="center"  label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="320">
        <template slot-scope="scope">
          <el-button @click="changeClick(scope)"
            style="color:#185ED3;font-weight:bold;font-size:13px;"
            type="text" class="btn" size="small">
            <i style="margin-right:3px;" class="el-icon-edit-outline"> </i>
            修改
          </el-button>
          <span style="margin:0 11px;"> | </span>
          <el-button @click="openBoxOfChangeStatus(scope.row)"
            style="font-weight:bold;font-size:13px;"
            :style="scope.row.status ==0 ?'color:#07f54e':'color:#F96900'"
            type="text"
            class="btn"
            size="small">
            
            <i v-if="scope.row.status == 1 " style="margin-right:3px;" class="el-icon-circle-close"></i>
            <i v-else style="margin-right:3px;" class="el-icon-circle-check"></i>
            {{ scope.row.status ==0 ?'启用':'停用' }}
          </el-button>
          <!-- <span style="margin:0 11px;"> | </span>
          <el-button @click="removeClick(scope)" style="color:#FF4545;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>

    <mydialog 
      @dialogSubmit="dialogSubmit" 
      :title="title"    
      :myform="myform"
      :label="label"
      :dialogFormVisible="dialogFormVisible">
    </mydialog>
  </div>
</template>

<script>
import { departmentdialog } from '@/components/index'
import { mapActions } from 'vuex'
import { getLabel } from "@/api/customLabel";
// import { getDate,formatConversion } from "@/plugins/getdate";
export default {
  name: 'picmanagetable',
  props: {
    tableData: Array,
  },
  components: {
    'mydialog': departmentdialog
  },

  watch: {
    '$store.state.user.dialogFormVisible' (data) {
      this.dialogFormVisible = data
    },
    'myform' (data) {
      this.myform = data
      console.log(this.myform)
    },
  },


  data () {
    return {
      label: ['部门名称', '状态'],
      title: '修改部门信息',
      myform: {},
      dialogFormVisible: this.$store.state.user.dialogFormVisible,
      changeData: [],
      dataIndex: 0,  //需要改变table的索引
      // tableData:[
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'52个',
      //     pics:'630张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'人文图片库',
      //     picj:'5个',
      //     pics:'30张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'0个',
      //     pics:'0张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'1234个',
      //     pics:'95487张',
      //   },
      // ]
    }
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),
    changeClick(scope) {
      console.log(scope.row);
      this.myform = {
        one: scope.row.name,
        two: scope.row.status,
        three:scope.row.id
      }
      // this.getLibAsync(scope.row.name)
      this.setDialogFormVisible(true)

    },
    
    openBoxOfChangeStatus(rowData) {
      this.$confirm('确定切换部门状态?', '切换部门状态', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
			this.changeStatus(rowData);
      })
      .catch(() => {
        this.$message({
            type: 'info',
            message: '取消修改'
          }); 
      });;
},
    async changeStatus(data) {
      let params = {
        id: data.id,
        status:data.status==0?1:0
      }
      this.$emit('changeStatus',params)
      // const { status, message } = await changeLabelStatusPicApi(params);
      // if (status) {
      //   ElMessage.success({ message: `${message}` });
      //   proTable.value.getTableList();
      // } else {
      //   ElMessage.success({ message: `${message}` });
      // }
    },
    //接受dialog组件提交之后传递过来的值
    dialogSubmit (data) {
      this.$emit('formSubmit', data)
    },





    //查询图片库
    async getLibAsync (val) {
      let { status, data, message, errors } = await getLabel(val);
      if (status) {
        this.myform = {
          one: data.labelName,
          two: data.labelClass,
          three: data.sort,
          ...data
        }
        // console.log(this.myform)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created () {

  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
</style>
